export enum LOGIN_WITH_TOKEN_ERROR {
	INVALID = 'An invalid login link was used. Please enter your email and click "Email Login Link" to request a new link.',

	EXPIRED = 'The login link has expired. Please enter your email and click "Email Login Link" to request a new link.',

	ALREADY_USED = 'The login link was already used. Please enter your email and click "Email Login Link" to request a new link.'
}
